import { FC } from 'react';
import { Helmet } from 'react-helmet';
import environment from 'src/utils/environments';

interface AppHeaderProps {}

const AppHeader: FC<AppHeaderProps> = () => {
  return (
    <Helmet>
      <meta charSet="utf-8" />

      <title>{environment.IS_DEV_ENV ? 'Dev - ' : ''}Lionshare Client</title>
    </Helmet>
  );
};

export default AppHeader;
